<div class="reports">
  <div class="search-wrapper">
    <app-input-search [placeholder]="'search_by_id'" (searchValue)="handleSearch($event)" [numberInput]="true"></app-input-search>
  </div>
  <div class="table-wrapper">
    <div class="activity-table-container">
      <table>
        <thead>
          <tr>
            <th class="table-padding"></th>
            <th class="id">ID</th>
            <th class="normal">{{ "view_translations.generation_date" | translate }}</th>
            <th class="normal">{{ "view_translations.payouts_own_invoice_loaded_format" | translate }}</th>
            <th class="normal">{{ "view_translations.action_button" | translate }}</th>
            <th class="table-padding"></th>
          </tr>
        </thead>
        <tbody [ngClass]="(isLoading || (!reports.length && !isLoading && !isError)) ? 'loading' : ''">
          <app-join-program-alert
            *ngIf="!isLoading && isError"
            [containerText]="{withTranslation: true, text: 'error_occured'}"
            type="danger"></app-join-program-alert>
          <app-loader *ngIf="isLoading"></app-loader>
          <ng-container *ngIf="reports.length > 0 && !isLoading && !isError">
            <tr *ngFor="let report of reports | search: searchValue: ['id']">
              <td class="table-padding"></td>
              <td class="id">{{ report.id }}</td>
              <td class="normal">{{ report.created_at | date: "dd.MM.yyyy, H:mm" | changeDateFormat: "at":"normal" }}</td>
              <td class="normal">{{ report.file_type }}</td>
              <td class="normal">
                <div class="d-flex align-items-center">
                  <div class="download-button">
                    <app-secondary-button
                      [iconSize]="12"
                      [text]="'download_button'"
                      [icon]="'file'"
                      [largeButton]="false"
                      [backgroundColor]="'grey'"
                      (emitAction)="handleDownloadReport(report.name)">
                    </app-secondary-button>
                  </div>
                  <div class="circle-button">
                    <app-circle-buttons [icon]="'basket-filled'" [cancelButton]="true" [iconSize]="'9'" (emitAction)="handleDeleteReport(report.name)">
                    </app-circle-buttons>
                  </div>
                </div>
              </td>
              <td class="table-padding"></td>
            </tr>
          </ng-container>
          <div class="empty" *ngIf="!reports.length && !isLoading && !isError">
            <p>{{ 'raports_empty' | t }}</p>
          </div>
        </tbody>
      </table>
    </div>
  </div>
</div>
